// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3AsmN","imageUploader":"EGiftCard_imageUploader__NIGWt"};